"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = FeatureFlag;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Context = require("./Context");

var _FeatureFlagRenderer = require("./FeatureFlagRenderer");

var _FeatureFlagRenderer2 = _interopRequireDefault(_FeatureFlagRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FeatureFlag(props) {
  return _react2.default.createElement(
    _Context.LaunchDarklyConsumer,
    null,
    function (config) {
      if (config) {
        return _react2.default.createElement(_FeatureFlagRenderer2.default, _extends({}, config, props));
      }

      return null;
    }
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/react-launch-darkly/build/components/FeatureFlag.js
// module id = 1146
// module chunks = 0